import { Box, Collapse, Grid, IconButton } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { COLORS } from "constants/colors";
import useText from "constants/text";
import { NewRequestQuoteContext } from "contexts/RequestQuoteContext";
import { EActionType, EVehiclesInput, Stop as StopType } from "generated/graphql";
import { VanIcon } from "icons";
import React from "react";
import styled from "styled-components";
import { parseTourStops } from "../shared/utils";
import { useRowStyles } from "../Tour/refontTourRequest/style";
import Stop from "./Stops";

export const Connector = styled.div`
  &.pickup {
    display: none;
  }
`;

export const StopLabel = {
  [EActionType.Pickup]: "P",
  [EActionType.Delivery]: "D",
  [EActionType.PickupDelivery]: "P/D",
  [EActionType.Unknown]: "S",
};

interface dataProps {
  data: EVehiclesInput[];
}

const VehicleInfos = ({ data }: dataProps) => {
  const classes = useRowStyles();
  const [isShown, setIsShown] = React.useState(false);
  const renderVehicles = () =>
    data?.map((vehicle, index) => (
      <li key={index} className={classes.li}>
        <VanIcon height={24} width={24} color={COLORS.primary} />
        &nbsp;
        {`${vehicle?.numberOfVehicule} ${vehicle?.vehicleType.replace(/_/g, " ")}`}
      </li>
    ));
  const getNumberOfVehicles = (vehicles: EVehiclesInput[]) =>
    vehicles?.reduce((prev, next) => prev + next.numberOfVehicule, 0);

  return (
    <div className={classes.divStyled} onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>
      <div className={classes.icon}>
        <VanIcon height={16} width={20} />
      </div>
      <div className={classes.divNumber}>{getNumberOfVehicles(data)}</div>
      {isShown && (
        <div className={classes.divContainerDropdown}>
          <div className={classes.divContainerUl}>
            <ul className={classes.ulDopdownStyled}>{renderVehicles()}</ul>
          </div>
        </div>
      )}
    </div>
  );
};

interface CollipsableStopsProps {
  requestQuoteNT: any;
}

const NTCollipsableStops = ({ requestQuoteNT }: CollipsableStopsProps) => {
  const { step } = React.useContext(NewRequestQuoteContext);
  const classes = useRowStyles();
  const { text } = useText();
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (step === 3) {
      setOpen(true);
    }
  }, [step]);

  return (
    <>
      <div className={classes.divContainer}>
        <Grid className={classes.root}>
          <Box className={classes.axes}>Stops</Box>
          <Box className={classes.vehicleInfo}>
            {requestQuoteNT?.vehicles?.length > 0 && <VehicleInfos data={requestQuoteNT?.vehicles} />}
          </Box>
          <Box className={classes.collapse}>
            <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>
        </Grid>
        <Collapse in={open} timeout="auto" unmountOnExit className={classes.collapseStop}>
          {parseTourStops(requestQuoteNT?.stops)?.map((stop, index) => (
            <Stop key={index} isLast={index === requestQuoteNT?.stops?.length - 1} stop={stop} />
          )) ||
            parseTourStops(requestQuoteNT?.templateStops)?.map((stop: StopType, index: number) => (
              <Stop key={index} isLast={index === requestQuoteNT?.templateStops?.length - 1} stop={stop} />
            ))}
        </Collapse>
      </div>
    </>
  );
};

export default NTCollipsableStops;
